import { render, staticRenderFns } from "./StockNameWithMark.vue?vue&type=template&id=31043e3e"
import script from "./StockNameWithMark.vue?vue&type=script&lang=js"
export * from "./StockNameWithMark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports